var Handlebars = require("/root/project/webapp/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    return "    <a style=\"font-weight: 700;\" class=\"btn btn-primary btn-raised login-button\" href=\""
    + container.escapeExpression(container.lambda((depth0 != null ? depth0.loginUrlForIdLogin : depth0), depth0))
    + "\">\n        ID、パスワードを使ってログイン\n    </a>\n";
},"3":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {});

  return "    <p>\n        <a style=\"font-weight: 700;\" class=\"btn btn-raised login-button google-login\" href=\""
    + alias2(alias1((depth0 != null ? depth0.loginUrlForGoogle : depth0), depth0))
    + "\">\n            <i class=\"fa fa-google\"></i>\n            "
    + alias2(__default(require("/root/project/webapp/src/common/ui/template/helper/i18n.js")).call(alias3,"signin:google-login",{"name":"i18n","hash":{},"data":data}))
    + "\n        </a>\n    </p>\n    <p>\n        <a style=\"font-weight: 700;\" class=\"btn btn-raised login-button quadcept-login\" href=\""
    + alias2(alias1((depth0 != null ? depth0.loginUrlForQuadcept : depth0), depth0))
    + "\">\n            Q\n            "
    + alias2(__default(require("/root/project/webapp/src/common/ui/template/helper/i18n.js")).call(alias3,"signin:quadcept-login",{"name":"i18n","hash":{},"data":data}))
    + "\n        </a>\n    </p>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.idLogin : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data})) != null ? stack1 : "");
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./common/ui/template/login-buttons.hbs
// module id = 1293
// module chunks = 0